import { Pipe, PipeTransform } from '@angular/core';
import { calcAgo } from '@mri/functions';

@Pipe({
  name: 'renderAgo',
  standalone: true
})
export class RenderAgoPipe implements PipeTransform {

  transform(value: string | Date): string {
    return calcAgo(value);
  }

}
